import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {OrganiserService} from "@services";
import {Organiser} from "@model";

export const OrganizersListReslover: ResolveFn<Observable<Organiser[]>> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   organiserService: OrganiserService = inject(OrganiserService)): Observable<Organiser[]> => {
    return organiserService.getOrganisers();
  }

export const MeasurersListReslover: ResolveFn<Observable<Organiser[]>> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   organiserService: OrganiserService = inject(OrganiserService)): Observable<Organiser[]> => {
    return organiserService.getMeasurers();
  }
